import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from '@mui/material';

import Icon from '../Icon/Icon';

type Props = {
    href: string;
    text: string;
};

const DocumentLink = ({ href, text }: Props) => {
    const theme = useTheme();

    return (
        <>
            <a
                href={href}
                target="_blank"
                rel="noreferrer noopener"
                style={{ color: theme.palette.primary.main, paddingRight: '6px' }}>
                {text}
            </a>
            <Icon icon={faArrowUpRightFromSquare} size="xs" />
        </>
    );
};

export default DocumentLink;
